import React from 'react';
import classNames from 'classnames';
import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import { languagesHelper as language } from '../../util/languages';

import {
  NamedLink,
  IconButtonArrow,
  IconSearch,
  IconLandscapes
} from '../../components';

import css from './LandscapeCard.module.css';
import { parseLandscapeCardText } from '../../util/cmsPageHelper';

const FieldMedia = props => {
  const { className, media, sizes, options } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
};
/**
 * LandscapeCard
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to component's own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {Object} props.listing API entity: listing or ownListing
 * @param {string?} props.renderSizes for img/srcset
 * @param {Function?} props.setActiveListing
 * @param {boolean?} props.showAuthorInfo
 * @returns {JSX.Element} listing card to be used in search result panel etc.
 */
export const LandscapeCard = props => {
  const config = useConfiguration();
  const intl = props.intl || useIntl();

  const {
    className,
    rootClassName,
    landscape,
    isGrid
  } = props;

  const locale = language.get();
  const classes = classNames(rootClassName || css.root, className);

  const searchUrl = landscape?.callToAction?.href?.replace("/s?", "");
  const pageId = landscape?.media?.link?.href?.replace("/p/", "");
  const media = landscape?.media;

  const description = landscape?.text?.content;
  const { subTitle, text } = parseLandscapeCardText(description);



  return (
    <NamedLink className={classes} name="CMSPage" params={{ pageId }}>
      <div className={css.rootForImage}>
        <FieldMedia
          media={media}
          sizes={"(max-width: 767px) 100vw, 568px"}
        />

      </div>
      {pageId && (
        <div className={css.landscape}>
          <IconLandscapes type={pageId.replace("landscape-", "")} />
        </div>
      )}
      <div className={css.info}>
        <div className={css.infoMain}>
          <div className={css.category}>
            {subTitle}
          </div>
          <h3 className={css.title}>
            {landscape?.title?.content}
          </h3>
          <p className={css.description}>
            {text}
          </p>
        </div>

        <div className={classNames(css.actionButtons, isGrid && css.actionButtonsGrid)}>
          <NamedLink className={css.pageLink} name="CMSPage" params={{ pageId }}>
            <IconButtonArrow />
            <FormattedMessage id="LandscapeCard.readFullStory" />
          </NamedLink>

          <NamedLink className={css.searchLink} name="SearchPage" to={{ search: searchUrl }}>
            <IconSearch />
            <FormattedMessage id="LandscapeCard.searchForListings" />
          </NamedLink>
        </div>
      </div>
    </NamedLink>
  );
};

export default LandscapeCard;
